import React, { useState } from "react"
import "./WhatsAppFAB.scss"

export default function WhatsAppFAB() {
	const [isActive, setActive] = useState(false);

  const toggleClass = () => {
    setActive(!isActive);
  };

	return(
		<>
			<div className={`wa-button ${isActive ? 'open': ''}`} onClick={toggleClass} />
			<a href="https://wa.me/+5493644698336" rel="noreferrer" target="_blank" className={`localidades-button sp-rent-button ${isActive ? 'active': ''}`}>
				Alquileres - Sáenz Peña
			</a>
			<a href="https://wa.me/+5493644525305" rel="noreferrer" target="_blank" className={`localidades-button sp-sell-button ${isActive ? 'active': ''}`}>
				Ventas - Sáenz Peña
			</a>
			<a href="https://wa.me/+5493624283820" rel="noreferrer" target="_blank" className={`localidades-button resis-rent-button ${isActive ? 'active': ''}`}>
				Alquileres - Resistencia
			</a>
			<a href="https://wa.me/+5493624283839" rel="noreferrer" target="_blank" className={`localidades-button resis-sell-button ${isActive ? 'active': ''}`}>
				Ventas - Resistencia
			</a>
		</>
	)
}
